import { Colors } from "../../styles/theme";

const styles = {
  Button_primary: {
    backgroundColor: Colors.primary,
    color: Colors.white,
    fontSize: { xs: "1rem", sm: "1.125rem" },
    lineHeight: 1.2,
    margin: 0.5,
    px: { xs: 1.75, sm: 3 },
    py: 1,
    textTransform: "none",
    "&:hover": {
      backgroundColor: Colors.primaryHover,
    },
  },
  Button_secondary: {
    backgroundColor: Colors.white,
    color: Colors.primary,
    fontSize: { xs: "1rem", sm: "1.125rem" },
    lineHeight: 1.2,
    textTransform: "none",
    margin: 0.5,
    px: { xs: 1.75, sm: 3 },
    py: 1,
    borderColor: Colors.primary,
    border: 0.5,
  },
};

export default styles;
